export class SignUtils {

    getElementForSign(signId: string): string {
        switch (signId) {
            case 'aries':
            case 'sagittarius':
            case 'leo':
                return 'fire';
            case 'taurus':
            case 'virgo':
            case 'capricorn':
                return 'earth';
            case 'gemini':
            case 'libra':
            case 'aquarius':
                return 'air';
            case 'cancer':
            case 'scorpio':
            case 'pisces':
                return 'water';
            default:
                return '';
        }
    }

    getGardenForSign(signId: string): string {
        switch (signId) {
            case 'aries':
            case 'sagittarius':
            case 'leo':
                return 'fruit';
            case 'taurus':
            case 'virgo':
            case 'capricorn':
                return 'root';
            case 'gemini':
            case 'libra':
            case 'aquarius':
                return 'blossom';
            case 'cancer':
            case 'scorpio':
            case 'pisces':
                return 'leaf';
            default:
                return '';
        }
    }

    getOrganSystemForSign(signId: string): string {
        switch (signId) {
            case 'aries':
            case 'sagittarius':
            case 'leo':
                return 'sensory';
            case 'taurus':
            case 'virgo':
            case 'capricorn':
                return 'blood';
            case 'gemini':
            case 'libra':
            case 'aquarius':
                return 'gland';
            case 'cancer':
            case 'scorpio':
            case 'pisces':
                return 'nerves';
            default:
                return '';
        }
    }

    getDayQualityForSign(signId: string): string {
        switch (signId) {
            case 'aries':
            case 'sagittarius':
            case 'leo':
                return 'warm';
            case 'taurus':
            case 'virgo':
            case 'capricorn':
                return 'cold';
            case 'gemini':
            case 'libra':
            case 'aquarius':
                return 'light';
            case 'cancer':
            case 'scorpio':
            case 'pisces':
                return 'water';
            default:
                return '';
        }
    }

    getNutritionQualityForSign(signId: string): string {
        switch (signId) {
            case 'aries':
            case 'sagittarius':
            case 'leo':
                return 'protein';
            case 'taurus':
            case 'virgo':
            case 'capricorn':
                return 'salt';
            case 'gemini':
            case 'libra':
            case 'aquarius':
                return 'fat';
            case 'cancer':
            case 'scorpio':
            case 'pisces':
                return 'carbs';
            default:
                return '';
        }
    }

    getDirectionForSign(signId: string): string {
        switch (signId) {
            case 'aries':
            case 'taurus':
            case 'sagittarius':
            case 'capricorn':
            case 'aquarius':
            case 'pisces':
                return 'ascending';
            case 'gemini':
            case 'cancer':
            case 'leo':
            case 'virgo':
            case 'libra':
            case 'scorpio':
                return 'descending';
            default:
                return '';
        }
    }
}
